import { createStore } from 'vuex'
import { auth } from "./auth.module";


export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    auth
  }
})
